import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconThumbsDown16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconThumbsDown16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m10.876 9.014 1.497.008a.5.5 0 0 0 .503-.5V4.498a.5.5 0 0 0-.5-.5h-1.5zm-1-5.016H4.935a.5.5 0 0 0-.471.333L3.03 8.363a.5.5 0 0 0 .471.667h3.375v3.982l2.7-3.6.3-.4zM3.501 10.03h2.375v2.982c0 .96 1.223 1.368 1.8.6l2.7-3.6 1.992.01a1.5 1.5 0 0 0 1.508-1.5V4.498a1.5 1.5 0 0 0-1.5-1.5H4.935c-.635 0-1.201.4-1.414.998L2.088 8.028A1.5 1.5 0 0 0 3.5 10.03"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconThumbsDown16);
